<template lang="pug">
<div>
  <el-upload ref="upload" class="file-input" action='#' :auto-upload='false' :file-list='fileList' list-type='picture-card' :on-change='fileChange' :on-remove='updateFiles' >
    <i slot="default" class="el-icon-plus"></i>
    <div style="width: 100%; height: 100%; text-align: center;" slot="file" slot-scope="{file}">
      <div style="width: 100%; height: 100%;" class="images" v-viewer="{movable: false}">
        <img style="max-width: 100%;" :src="file.url">
      </div>
      <span class="el-upload-list__item-actions">
        <span title="预览图片" class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
          <i class="el-icon-zoom-in"></i>
        </span>
        <span title="删除图片" class="el-upload-list__item-delete" @click="handleRemove(file)">
          <i class="el-icon-delete"></i>
        </span>
      </span>
    </div>
  </el-upload>
</div>
</template>
<script>
  import app from "../js/app";
  import ElImageViewer from "element-ui/packages/image/src/image-viewer";
  import Viewer from "viewerjs";
  import "viewerjs/dist/viewer.css";
  export default {
    model: {
      prop: "value",
      event: "change",
    },
    props: {
      disabled: Boolean,
      value: {},
      multiFileTime: Boolean,
    },
    name: "Index",
    components: { ElImageViewer },
    data() {
      console.log(this.value);
      //初始化旧文件
      var fileList = [];
      if (this.value != null && this.value != "")
        fileList = this.value
          .split(",")
          .map((v) => ({ name: v.slice(v.lastIndexOf("/")), url: v }));
      return {
        fileList,
        showViewer: false, // 显示查看器
        url: "",
      };
    },
    computed: {
      urls() {
        //解决上传的和旧的图文件结构不一致
        var urls = [];
        for (var f of this.fileList) {
          if (f.raw) urls.push(f.raw.uploadedUrl);
          else urls.push(f.url);
        }
        return urls.join(",");
      },
    },
    watch: {
      urls(val) {
        this.$emit("change", val);
      },
      value(val) {
        if (val == "" || val == null) {
          this.fileList = [];
        } else {
          this.fileList = val
            .split(",")
            .map((v) => ({ name: v.slice(v.lastIndexOf("/")), url: v }));
        }
      },
    },
    methods: {
      fileChange(f, fileList) {
        var file = f.raw,
          canUpload = false;
        if (!file.type.startsWith("image/")) {
          this.$message.error("上传只能是图片格式!");
        } else if (file.size / 1024 > 1024 * 10) {
          this.$message.error("上传图片大小不能超过 10MB!");
        } else if (this.fileList.length >= 9) {
          this.$message.error("最多9张图片");
        } else {
          canUpload = true;
          this.uploadFile(file, fileList);
        }
        if (!canUpload) this.fileList = fileList.slice(0, fileList.length - 1);
      },
      uploadFile(file, fileList) {
        var formData = new FormData();
        formData.append("file", file);
        app
          .post(
            "fileUpload",
            { file: file.name.slice(0, file.name.lastIndexOf(".")) },
            this.$el,
            formData
          )
          .then((d) => {
            this.$message.success("上传图片成功");
            file.uploadedUrl = d.result[0];
            this.fileList = fileList;
            //志愿者详情页获取上传的第一张的时间
            if (fileList.length == 1)
              this.$emit("first-file-time", file.lastModifiedDate);
            if (this.multiFileTime)
              this.$emit("multi-file-time", {
                lastModifiedDate: file.lastModifiedDate,
                id: file.uploadedUrl,
              });
          });
      },
      updateFiles(file, fileList) {
        this.fileList = fileList;
        if (this.multiFileTime) this.$emit("time-change", file.url);
      },
      // 预览
      handlePictureCardPreview(file) {
        for (let i = 0; i < this.$el.querySelectorAll(".images").length; i++) {
          if (
            file.url ===
            this.$el.querySelectorAll(".images")[i].getElementsByTagName("img")[0]
              .src
          ) {
            const viewer = this.$el.querySelectorAll(".images")[i].$viewer;
            viewer.show();
            break;
          }
        }
      },
      handleRemove(file) {
        this.$refs.upload.handleRemove(file)
      }
    },
  };
</script>

<style lang='stylus'>
  .preview img {
    width: 148px;
    height: 148px;
  }

  .el-table__fixed-body-wrapper {
    z-index: auto !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/multi-image-input.vue